// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"6599b93fcac7509c9340","415":"742200050bbe7885c418","452":"f2340132e118c5edc830","522":"da76c01667875987a983","551":"826cbf88c32b73cb6ffe","577":"8b6a37be06adb9c524b6"}[chunkId] + ".js";
};